/**
 * Compare two IDs that may arrive as `string` from one backend env and `number`
 * from another (PHP returns `"801"`, Go returns `801`). Strict `===` silently
 * fails on this drift. Normalize to string before comparing.
 *
 * Returns `false` when either side is `null` / `undefined` (never equal to anything).
 *
 * NOTE: when used to negate (`!sameId(a, b)` as a "filter self out" callback),
 * the both-nullish case now returns `true` (keeps the item) whereas plain
 * `a !== b` returned `false` (dropped the item). Guard the reference side
 * (e.g. `currentUser`) explicitly first if you rely on the old behavior:
 *   `if (!this.currentUser || sameId(user.id, this.currentUser.id)) { ... }`
 */
export function sameId(a: string | number | null | undefined, b: string | number | null | undefined): boolean {
  return a != null && b != null && String(a) === String(b)
}
